(function () {
  const init = window.pdpInit;
  if (!init) return;

  let selectedColor = init.selectedColorHandle;
  let selectedLongueur = null;
  const colorQuantities = {};
  let activeDotsList = [];
  let carouselCurrent = 0;

  const productData = init.productData;
  const variantImageMap = init.variantImageMap;
  const colorRefMap = init.colorRefMap;
  const colorRefCodes = init.colorRefCodes || {};
  const refEl = document.getElementById('pdpRef');

  const colorSwatches   = document.querySelectorAll('.pdp__swatch');
  const selectedColorEl = document.getElementById('selectedColorName');
  const sizeInputs      = document.querySelectorAll('.pdp__size-input');
  const longueurBtns    = document.querySelectorAll('.pdp__longueur-btn');
  const totalQtyEl      = document.getElementById('totalQuantity');
  const addToCartBtn    = document.getElementById('addToCartBtn');
  if (longueurBtns.length > 0) {
    const initLongueurBtn = init.selectedLongueurHandle
      ? Array.from(longueurBtns).find(b => b.dataset.longueur === init.selectedLongueurHandle)
      : null;
    selectedLongueur = (initLongueurBtn || longueurBtns[0]).dataset.longueur;
  }

  function normalize(str) {
    return str.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/-/g, ' ');
  }

  function getColorLongueurKey() {
    return selectedLongueur ? selectedColor + '__' + selectedLongueur : selectedColor;
  }

  function variantMatch(variant, color, size, longueur) {
    const opts = variant.options;
    const colorVal    = opts.couleur || opts.color || '';
    const sizeVal     = opts.taille  || opts.tailles || opts.size || '';
    const longueurVal = opts.longueur || opts.coupe || '';
    if (normalize(colorVal) !== normalize(color)) return false;
    if (sizeVal !== size) return false;
    if (!longueur) return true;
    return normalize(longueurVal) === normalize(longueur);
  }

  function findVariantForColor(color, longueur) {
    const withLongueur = longueur && productData.variants.find(v => variantMatch(v, color, v.options.taille || v.options.tailles || v.options.size || '', longueur));
    if (withLongueur) return withLongueur;
    return productData.variants.find(v => normalize(v.options.couleur || v.options.color || '') === normalize(color));
  }

  function updateUrlVariant(color, longueur) {
    const variant = findVariantForColor(color, longueur);
    if (!variant || !window.history || !window.history.replaceState) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function saveCurrentColorQuantities() {
    const key = getColorLongueurKey();
    if (!colorQuantities[key]) colorQuantities[key] = {};
    sizeInputs.forEach(inp => {
      colorQuantities[key][inp.dataset.size] = parseInt(inp.value) || 0;
    });
  }

  function loadColorQuantities() {
    const key = getColorLongueurKey();
    if (!colorQuantities[key]) colorQuantities[key] = {};
    sizeInputs.forEach(inp => {
      inp.value = colorQuantities[key][inp.dataset.size] || 0;
    });
    updateTotalQuantity();
  }

  function updateTotalQuantity() {
    saveCurrentColorQuantities();
    let total = 0;
    Object.values(colorQuantities).forEach(map => Object.values(map).forEach(q => { total += q || 0; }));
    if (totalQtyEl) totalQtyEl.textContent = total;
  }

  function updateLongueurAvailability(color) {
    longueurBtns.forEach(btn => {
      const longueur = btn.dataset.longueur;
      const available = productData.variants.some(v => {
        const opts = v.options;
        const colorVal    = opts.couleur || opts.color || '';
        const longueurVal = opts.longueur || opts.coupe || '';
        return normalize(colorVal) === normalize(color) &&
               normalize(longueurVal) === normalize(longueur) &&
               v.available;
      });
      btn.classList.toggle('is-unavailable', !available);
      btn.disabled = !available;
      btn.style.opacity = available ? '' : '0.3';
      btn.style.cursor  = available ? '' : 'not-allowed';
    });
  }

  function updateSizeAvailability(color) {
    sizeInputs.forEach(inp => {
      const variant = productData.variants.find(v => variantMatch(v, color, inp.dataset.size, selectedLongueur));
      const available = variant && variant.available;
      inp.disabled = !available;
      if (!available) inp.value = 0;
      const item = inp.closest('.pdp__size-item');
      if (item) item.classList.toggle('is-unavailable', !available);
    });
    updateLongueurAvailability(color);
  }

  // ── Filtrage galerie par couleur ─────────────────────────────────────────
  function handleize(str) {
    return (str || '').trim().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function filterGalleryByColor(colorName) {
    const track = document.getElementById('pdpCarouselTrack');
    const dotsContainer = document.querySelector('.pdp__carousel-dots');
    if (!track || !dotsContainer) return;

    const slides = Array.from(track.querySelectorAll('.pdp__carousel-slide'));
    const colorHandle = handleize(colorName);
    // Le SKU (donc le préfixe PRODUCTREF_CODE) peut différer d'une longueur à l'autre pour
    // une même couleur : on teste tous les préfixes rencontrés, pas un seul.
    const skuRefs = (colorRefCodes[colorHandle] || []).map(r => r.toLowerCase());

    // Priorité 1 : variantImageMap (image directement attachée à la variante Shopify)
    const hasVariantMap = Object.keys(variantImageMap).length > 0;
    const colorInMap = hasVariantMap && slides.some(slide => {
      const id = slide.dataset.imageId;
      return id && variantImageMap[id] && variantImageMap[id].includes(colorHandle);
    });

    // Priorité 2 : nom de fichier (PRODUCTREF_COLORCODE_Vx.jpg)
    const getFilename = slide => {
      const src = slide.dataset.imageSrc || '';
      return src.split('/').pop().split('?')[0].toLowerCase();
    };
    const matchesFilename = slide => skuRefs.some(ref => getFilename(slide).startsWith(ref));
    const hasFilenameMatch = skuRefs.length > 0 && slides.some(matchesFilename);

    let visibleSlides = [];

    if (colorInMap) {
      slides.forEach(slide => {
        const id = slide.dataset.imageId;
        const colors = id ? variantImageMap[id] : null;
        const show = colors ? colors.includes(colorHandle) : matchesFilename(slide);
        slide.style.display = show ? '' : 'none';
        if (show) visibleSlides.push(slide);
      });
    } else if (hasFilenameMatch) {
      slides.forEach(slide => {
        const show = matchesFilename(slide);
        slide.style.display = show ? '' : 'none';
        if (show) visibleSlides.push(slide);
      });
    }

    // Filet de sécurité : afficher tout si rien n'est visible
    if (visibleSlides.length === 0) {
      slides.forEach(s => { s.style.display = ''; });
      visibleSlides = slides;
    }

    // Reconstruire les dots pour les slides visibles
    dotsContainer.innerHTML = '';
    const newDots = visibleSlides.map((slide, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp__carousel-dot' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Image ' + (i + 1));
      btn.addEventListener('click', () => {
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        newDots.forEach(d => d.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
      dotsContainer.appendChild(btn);
      return btn;
    });
    activeDotsList = newDots;
    carouselCurrent = 0;
    track.scrollTo({ left: 0, behavior: 'instant' });

    const gallery = track.closest('.pdp__gallery');
    if (gallery) gallery.classList.add('js-ready');
  }

  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function () {
      saveCurrentColorQuantities();
      colorSwatches.forEach(s => s.classList.remove('is-selected'));
      this.classList.add('is-selected');
      selectedColor = this.dataset.color;
      if (selectedColorEl) selectedColorEl.textContent = this.dataset.colorName;
      const colorNameEl = document.getElementById('pdpColorName');
      if (colorNameEl) colorNameEl.textContent = ' - ' + this.dataset.colorName;
      const colorPrefixEl = document.getElementById('pdpColorPrefix');
      if (colorPrefixEl) colorPrefixEl.textContent = this.dataset.colorName;

      loadColorQuantities();
      updateSizeAvailability(selectedColor);
      filterGalleryByColor(this.dataset.colorName);
      if (refEl && colorRefMap[selectedColor]) refEl.textContent = 'REF : ' + colorRefMap[selectedColor];
      updateUrlVariant(selectedColor, selectedLongueur);
    });
  });

  longueurBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      if (this.disabled) return;
      saveCurrentColorQuantities();
      longueurBtns.forEach(b => b.classList.remove('is-selected'));
      this.classList.add('is-selected');
      selectedLongueur = this.dataset.longueur;
      loadColorQuantities();
      updateSizeAvailability(selectedColor);
      updateUrlVariant(selectedColor, selectedLongueur);
    });
  });

  if (colorSwatches.length > 0) {
    const initColorHandle = init.selectedColorHandle;
    const initColorName   = init.selectedColorName;
    let initSwatch = initColorHandle
      ? Array.from(colorSwatches).find(s => s.dataset.color === initColorHandle)
      : null;
    // Fallback : comparaison normalisée sur le nom brut
    if (!initSwatch && initColorName) {
      const n = s => handleize(s);
      initSwatch = Array.from(colorSwatches).find(s => n(s.dataset.colorName) === n(initColorName));
    }
    if (!initSwatch) initSwatch = colorSwatches[0];
    colorSwatches.forEach(s => s.classList.remove('is-selected'));
    initSwatch.classList.add('is-selected');
    selectedColor = initSwatch.dataset.color;
    if (selectedColorEl) selectedColorEl.textContent = initSwatch.dataset.colorName;
    const colorNameElInit = document.getElementById('pdpColorName');
    if (colorNameElInit) colorNameElInit.textContent = ' - ' + initSwatch.dataset.colorName;
    const colorPrefixElInit = document.getElementById('pdpColorPrefix');
    if (colorPrefixElInit) colorPrefixElInit.textContent = initSwatch.dataset.colorName;
    loadColorQuantities();
    updateSizeAvailability(selectedColor);
    filterGalleryByColor(initSwatch.dataset.colorName);
    if (refEl && colorRefMap[selectedColor]) refEl.textContent = 'REF : ' + colorRefMap[selectedColor];
  }

  sizeInputs.forEach(inp => {
    inp.addEventListener('input', function () {
      if (parseInt(this.value) < 0) this.value = 0;
      const key = getColorLongueurKey();
      if (!colorQuantities[key]) colorQuantities[key] = {};
      colorQuantities[key][this.dataset.size] = parseInt(this.value) || 0;
      updateTotalQuantity();
    });
    inp.addEventListener('blur', function () {
      if (this.value === '' || isNaN(this.value)) this.value = 0;
      const key = getColorLongueurKey();
      if (!colorQuantities[key]) colorQuantities[key] = {};
      colorQuantities[key][this.dataset.size] = parseInt(this.value) || 0;
      updateTotalQuantity();
    });
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async function () {
      if (this.disabled) return;
      this.disabled = true;
      const origText = this.textContent;
      this.textContent = 'Ajout en cours…';
      saveCurrentColorQuantities();

      const cartItems = [];
      Object.keys(colorQuantities).forEach(key => {
        const parts = key.split('__');
        const color    = parts[0];
        const longueur = parts.length > 1 ? parts[1] : null;
        Object.keys(colorQuantities[key]).forEach(size => {
          const qty = colorQuantities[key][size];
          if (qty > 0) {
            const variant = productData.variants.find(v => variantMatch(v, color, size, longueur));
            if (variant) cartItems.push({ id: variant.id, quantity: qty });
          }
        });
      });

      if (cartItems.length === 0) {
        this.disabled = false;
        this.textContent = origText;
        alert('Veuillez sélectionner au moins un article.');
        return;
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });
        if (res.ok) {
          window.location.href = '/cart';
        } else {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.description || errData.message || "Erreur lors de l'ajout au panier");
        }
      } catch (err) {
        console.error(err);
        alert(err.message || 'Une erreur est survenue. Veuillez réessayer.');
        this.disabled = false;
        this.textContent = origText;
      }
    });
  }

  const guideBtn      = document.getElementById('pdpSizeGuideBtn');
  const guidePanel    = document.getElementById('pdpGuidePanel');
  const guideBackdrop = document.getElementById('pdpGuideBackdrop');
  const guideClose    = document.getElementById('pdpGuideClose');

  function openGuide() {
    if (!guidePanel) return;
    guidePanel.classList.add('is-open');
    guidePanel.setAttribute('aria-hidden', 'false');
    if (guideBackdrop) guideBackdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeGuide() {
    if (!guidePanel) return;
    guidePanel.classList.remove('is-open');
    guidePanel.setAttribute('aria-hidden', 'true');
    if (guideBackdrop) guideBackdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (guideBtn) guideBtn.addEventListener('click', openGuide);
  if (guideClose) guideClose.addEventListener('click', closeGuide);
  if (guideBackdrop) guideBackdrop.addEventListener('click', closeGuide);

  updateTotalQuantity();

  // Disponibilité temps réel — contourne le cache Liquid de Shopify
  fetch('/products/' + init.productHandle + '.js')
    .then(r => r.json())
    .then(data => {
      data.variants.forEach(sv => {
        const pv = productData.variants.find(v => v.id === sv.id);
        if (pv) pv.available = sv.available;
      });
      updateSizeAvailability(selectedColor);
    })
    .catch(() => {});

  // ── Carousel galerie — scroll-snap natif (mobile uniquement) ─
  const carouselTrack = document.getElementById('pdpCarouselTrack');
  const carouselDots  = document.querySelectorAll('.pdp__carousel-dot');
  activeDotsList = Array.from(carouselDots);
  const carouselTotal = carouselDots.length;

  if (carouselTrack && carouselTotal > 0) {
    // Clic sur un dot → scroll vers le slide
    carouselDots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        carouselTrack.scrollTo({ left: i * carouselTrack.offsetWidth, behavior: 'smooth' });
      });
    });

    // Mise à jour du dot actif au scroll
    carouselTrack.addEventListener('scroll', () => {
      const idx = Math.round(carouselTrack.scrollLeft / carouselTrack.offsetWidth);
      if (idx !== carouselCurrent) {
        carouselCurrent = idx;
        activeDotsList.forEach((d, i) => d.classList.toggle('is-active', i === carouselCurrent));
      }
    }, { passive: true });
  }
})();
